/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Table_Active1Inputs */

const en_settings_casmanagement_table_active1 = /** @type {(inputs: Settings_Casmanagement_Table_Active1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Settings_Casmanagement_Table_Active1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_table_active1 = /** @type {((inputs?: Settings_Casmanagement_Table_Active1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Table_Active1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_table_active1(inputs)
});
export { settings_casmanagement_table_active1 as "settings_casManagement_table_active" }